interface ApiConfig {
    url: string;
}

const apiConfig: ApiConfig = {
    url: '',
};

export default apiConfig;

export type { ApiConfig };
export { apiConfig };
